module.exports = __webpack_public_path__ + "static/media/resumeButton@3x.182ccb3b.png";